// extracted by mini-css-extract-plugin
module.exports = {"root":"AssetAccessChecker_root__lK3vD"};